import { FC, useEffect } from 'react'
import Image from 'next/image'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { UseGetAdByPlacementCodeAndCurrentTime_AdFragment } from 'generated/graphql'
import { GTM_EVENT } from '@app.feature/ad/constants/gtm'
import { pushGTMCampaignId } from '@app.feature/ad/modules/gtmEvents'
import { imageLoader, optimizeImageUrl } from 'utils/optimizeImageUrl'

interface IFProps {
  ad: UseGetAdByPlacementCodeAndCurrentTime_AdFragment
}

export const COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE = {
  width: 610,
  height: 80,
}

const CoverLetterSearchBannerDesktop: FC<IFProps> = ({ ad }) => {
  const router = useRouter()
  const activityUrl = ad.activity?.id ? `/activity/${ad.activity?.id}` : ''

  useEffect(() => {
    pushGTMCampaignId({
      eventName: GTM_EVENT.COVER_LETTER_SEARCH.PC.IMPRESSION_EVENT,
      campaignId: ad.campaign?.id || '',
    })
  }, [router.query.id])

  const handleClickOutLink = () => {
    pushGTMCampaignId({
      eventName: GTM_EVENT.COVER_LETTER_SEARCH.PC.CLICK_EVENT,
      campaignId: ad.campaign?.id || '',
    })

    if (ad.campaign?.landingURL) {
      window.open(ad.campaign.landingURL, '_blank', 'noopener, noreferrer')
    }
    if (activityUrl) {
      router.push(activityUrl)
    }
  }

  const alt = ad?.campaign?.campaignGroup?.name
    ? `${ad?.campaign?.campaignGroup?.name} 자만검 배너 이미지`
    : `자만검 배너 이미지`

  return (
    <StyledWrapper
      onClick={handleClickOutLink}
      aria-label="Advertisement"
      role="advertisement"
    >
      <Image
        key="cover-letter-search-banner-image"
        className="cover-letter-search-banner-image"
        alt={alt}
        width={COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.width}
        height={COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.height}
        loader={imageLoader}
        src={optimizeImageUrl({
          url: ad.image?.url,
          width: COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.width,
          height: COVER_LETTER_SEARCH_BANNER_PC_IMAGE_SIZE.height,
        })}
      />
    </StyledWrapper>
  )
}

export default CoverLetterSearchBannerDesktop

const StyledWrapper = styled.div`
  .cover-letter-search-banner-image {
    border-radius: 5px;
    cursor: pointer;
  }
`
